<template>
  <div>
    <Headersys />
    <div class="content">
      <div class="qrcode-box">
        <canvas id="qrCode"></canvas>
        <div class="tips">
          1、手机扫描二维码进入上传页，图片上传完成后点击打印按钮开始打印。打印完毕请及时取走资料。
        </div>
        <div class="tips">
          2、安卓手机使用微信扫码可以从手机相册内选取一张图片，安卓手机使用浏览器扫码或苹果手机扫码可上传多张图片，确定上传后即可打印
        </div>
        <div class="tips-admin">注意:体积比较大的文件或者图片可能无法上传</div>
      </div>
      <div class="file-box">
        <!-- <div class="file-card" v-for="(item, idx) in  fileList" :key="idx">
          <img class="file-img" v-if="item.type == 'image_url'" :src="item.url" alt="">
          <div class="file-img pdf" v-if="item.type == 'pdf_url'">{{ item.fileName }}</div>
          <div class="delt" @click="delt(idx)">×</div>
        </div> -->
        <div>
          <el-table
            :data="fileList"
            stripe
            style="width: 100%; border-color: #000"
          >
            <el-table-column prop="fileName" label="文件名"> </el-table-column>
            <el-table-column prop="name" label="操作" width="120">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-delete"
                  @click="delt(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="load-mask" id="loadDom" v-if="maskShow"></div>
    </div>
    <Back :print="print" @toPrintEve="toPrintEve(0)" />
  </div>
</template>
<script>
import QRCode from "qrcode";
import { v4 as uuidv4 } from "uuid";
import lodop from "@/assets/js/doPrint.js";
import { Loading } from "element-ui";

export default {
  name: "",
  data() {
    return {
      //
      uuid: "",
      getTimer: null,
      fileList: [],
      print: "1",
      waitTime: 290,
      watiTimer: null,
      printTotal: 0,
      maskShow: false,
      loadingInstance: null,
      fmac: "",
      phone: "",
      name: "",
      idCard: "",
    };
  },
  created() {
    //
  },
  beforeDestroy() {
    // console.log('清除定时器');
    clearTimeout(this.getTimer);
    clearTimeout(this.watiTimer);
  },
  mounted() {
    //
    this.uuid = "";
    this.openQRCode();
    this.timeDown();
    this.$fun.getMAC((mac) => {
      this.fmac = mac;
    });
    var userInfo = this.$store.state.suerInfo;
    this.name = userInfo.name;
    this.phone = userInfo.tel;
    this.idCard = userInfo.cerno;
    this.checkPrintCurrent();
  },
  methods: {
    toPrintEve(idx) {
      if (this.printTotal <= 0) {
        this.messageToast("单人每天限制打印10张");
        return;
      }
      if (idx > this.fileList.length - 1) {
        return;
      }
      this.maskShow = true;
      setTimeout(() => {
        if (!this.loadingInstance) {
          this.loadingInstance = Loading.service({
            fullscreen: true,
            text: "正在打印...",
            target: document.querySelector("#loadDom"),
          });
          setTimeout(() => {
            this.loadingInstance.close();
          }, 16000);
        }
      }, 500);
      var content = this.fileList[idx];
      if (content.type == "image_url") {
        lodop.zzPrint(
          content.url.replace(
            "https://kzznzd.zwfwpt.cn/yyzz",
            "http://123.131.74.135:9000/yyzz"
          )
        );
        this.savePrintRecord(1);
        this.printTotal--;
        if (this.printTotal <= 0) {
          this.messageToast("单人每天限制打印10张");
          return;
        }
        // else {
        //   this.toPrintEve(idx + 1)
        // }
      }
      if (content.type == "pdf_url") {
        lodop.pdfPrint(content.url, this.printTotal, (page) => {
          // console.log('打印页数', page);
          this.savePrintRecord(page);
          this.printTotal = this.printTotal - page;
          if (this.printTotal <= 0) {
            this.messageToast("单人每天限制打印10张");
            return;
          }
        });
      }
      this.toPrintEve(idx + 1);
    },
    messageToast(content) {
      this.$alert(content, "提示", {
        confirmButtonText: "确定",
      });
    },
    // 检查剩余打印次数
    checkPrintCurrent() {
      this.$rqt
        .print_getPrintLastNumber({
          idCard: this.idCard,
          type: "上传打印",
        })
        .then((res) => {
          this.printTotal = 10 - res.data;
          console.log("剩余打印次数", this.printTotal);
        });
    },
    // 保存打印记录
    savePrintRecord(count) {
      for (let index = 0; index < count; index++) {
        this.$rqt.print_save({
          type: "上传打印",
          fmac: this.fmac,
          name: this.name,
          phone: this.phone,
          idCard: this.idCard,
        });
      }
    },
    //
    openQRCode() {
      this.uuid = uuidv4().replaceAll("-", "");
      // this.uuid = 'a8869c9d25a64b52a2be43c3435d80e9'
      setTimeout(() => {
        this.useqrcode();
        this.getUserFile();
      }, 500);
    },
    // 获取用户上传文件
    getUserFile() {
      this.$rqt
        .common_getRecord({
          key: this.uuid,
        })
        .then((res) => {
          if (res.data) {
            this.fileList = res.data;
            this.print = "2";
          } else {
            this.print = "1";
          }
          // else {
          this.getTimer = setTimeout(() => {
            this.getUserFile();
          }, 3500);
          // }
        });
    },
    // 删除
    delt(idx) {
      this.fileList.splice(idx, 1);
      this.$rqt.common_saveRecord({
        key: this.uuid,
        value: this.fileList,
      });
    },
    // 生成二维码
    useqrcode() {
      var canvas = document.getElementById("qrCode");
      // 调用函数去生成二维码，参数依次为：二维码的容器、要生成的内容、回调函数   http://192.168.1.104:8080
      QRCode.toCanvas(
        canvas,
        `https://l.zwfwpt.cn/#/file?id=${this.uuid}&type=pic`,
        // `http://192.168.1.102:8080//#/file?id=${this.uuid}&type=pic`,
        function (error) {
          if (error) {
            console.error(error);
          } else {
            // console.log("success!");
          }
        }
      );
    },
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--;
        } else {
          this.waitTime = 290;
          clearInterval(this.watiTimer);
          this.$router.replace("/");
        }
      }, 1000);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  // width: 70%;
  height: calc(100vh - 42rem - 40px);
  padding: 20px;
  // margin: auto;
  background-color: #fff;
  position: relative;
  // overflow: scroll;
  display: flex;
  align-items: center;
}

.qrcode-box {
  width: 35%;
}

#qrCode {
  width: 60rem !important;
  height: 60rem !important;
  margin: auto !important;
  display: block !important;
}

.file-box {
  width: 65%;
  height: calc(100vh - 42rem - 40px);
  overflow-y: scroll;
  // display: flex;
  flex-wrap: wrap;
  background-color: rgba($color: #bbb6b6, $alpha: 0.1);
}

.file-box::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.file-card {
  width: 31%;
  height: 50rem;
  margin: 0 1% 10px;
  position: relative;
  // display: inline-block;
  float: left;
}

.delt {
  position: absolute;
  top: 0px;
  right: 10px;
  font-size: 12rem;
  font-weight: bold;
}

.file-img {
  display: block;
  width: 100%;
  height: 50rem;
}

.pdf {
  // text-align: center;
  // line-height: 50rem;
  color: #ffffff;
  background-color: #ff0000;
  // font-size: 20rem;
  font-size: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tips {
  font-size: 4rem;
  margin-bottom: 10px;
}

.tips-admin {
  font-size: 5rem;
  color: #ff0000;
  font-weight: bold;
}

.load-mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  // background-color: red;
}

::v-deep .el-table th {
  border-color: rgb(152, 151, 151) !important;
}

::v-deep .el-table td {
  border-color: rgb(198, 196, 196) !important;
}

::v-deep .el-table--group,
::v-deep .el-table--border {
  border: 0.1px solid rgb(152, 151, 151) !important;
}
</style>